/*
 * @Description:
 * @Date: 2022-09-20 11:36:22
 */

export const PERSON_TYPE = 1; //个人
export const INDIVIDUAL_TYPE = 2; //个体
/**
 * 支付方式 1 线上支付  2线下支付
 */
export const PAYTYPE_MAPPING = {
  1: {
    value: 1,
    label: '线上支付'
  },
  2: {
    value: 2,
    label: '线下支付'
  }
};
